module.exports = __webpack_public_path__ + "img/payment.6e87e4de.png";